<template>
  <!--  -->
  <span
    :class="{ 'opacity-50 cursor-not-allowed': disabled }"
    @click="handleClick"
  >
    <!--  -->
    <Icon :icon="icon" :class="iconClass" :disabled="disabled" />
    <!--  -->
  </span>
  <!--  -->
</template>

<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon,
  },
  props: {
    icon: {
      type: String,
      default: "heroicons-outline:home",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
